/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckPayment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function CheckPayment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Content/Content/Transaction/EntityType/Payment/PaymentMethod/CheckPayment"
  
}) {
let entryAppliedPaymentPaymentValueData = fromData.useDataFormat({ viewPath,
context: 'entry',
path: 'applied_payment.payment',
format: fromHelpers.getText,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 data="entry.applied_payment.payment"
 format="helpers.js getText"
 text={entryAppliedPaymentPaymentValueData}
/>
{children}
</React.Fragment>)
}